import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';

import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import { SpecificationEntity } from '../../../models/OrderManagement';


type SpecificationPropType = {
  data:SpecificationEntity[],
  tableHeader:string
}



const Specifications = ({data,tableHeader}:SpecificationPropType ) => {
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
          border:0
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14,
          border:0,
          lineHeight:12
        },
      }));
      const StyledTableRow = styled(TableRow)(({ theme }) => ({
        lineHeight:12
      }));

  return (
    <>
   <Box className="container" sx={{width: "100%"}}>
   <Typography mt={1} className="table-heading">
      {tableHeader}
    </Typography>
    <TableContainer className="price-table">
    <Table  aria-label="customized table" className='show-action-column'>
        <TableBody>    
            {data && data.map((row:any) => {
                return <StyledTableRow key={row.name}>
                    <StyledTableCell align="left" >
                        <Typography lineHeight={1} fontWeight="bold">{row.name}</Typography>
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      <Typography lineHeight={1}>{row.value}</Typography>
                    </StyledTableCell>
                </StyledTableRow>
            })}   
        </TableBody>
    </Table>
</TableContainer>

   </Box>
    </>
  )
}

export default Specifications;